<app-no-internet-connection-alert />
<app-header />
<main [class.desktop]="resizeService.isDesktop()">
    <router-outlet />
</main>
@if (authService.isAuthenticated() === true && resizeService.isMobile()) {
<app-navbar />
} @else if (authService.isAuthenticated() === true) {
<app-side-nav />
}